import {createAsyncThunk} from '@reduxjs/toolkit';
import apiFetch from '@wordpress/api-fetch';
import constants from './constants';
import handleApiError from "../../utils/handleApiError";

export const addToCart = createAsyncThunk(constants.ADD_TO_CART, async (data) => {
    const result = await apiFetch({
        method: 'post',
        path: '/cart',
        data
    });
    return result;
})

export const updateCheckoutData = createAsyncThunk(constants.UPDATE_CHECKOUT_DATA, async data => {
    const result = await apiFetch({
        method: 'post',
        path: '/cart/update',
        data
    });
    return result;
});

export const addCouponCode = createAsyncThunk(constants.ADD_COUPON, async ({code, ...data}, {rejectWithValue}) => {
    try {
        const result = await apiFetch({
            method: 'post',
            path: '/cart/coupon',
            data: {
                code,
                ...data
            }
        });
        return result;
    } catch (error) {
        throw new Error(handleApiError(error));
    }
});

export const removeCouponCode = createAsyncThunk(constants.REMOVE_COUPON, async (code, {rejectWithValue}) => {
    try {
        const result = await apiFetch({
            method: 'delete',
            path: '/cart/coupon',
            data: {
                code
            }
        });
        return result;
    } catch (error) {
        if (error.errors) {
            throw new Error(error.errors[0].message);
        }
        return rejectWithValue(error);
    }
});

export const fetchCustomer = createAsyncThunk(constants.FETCH_CUSTOMER, async () => {
    try {
        const response = await apiFetch({
            method: 'get',
            path: '/customer'
        });
        return response;
    } catch (error) {
        throw new Error(handleApiError(error));
    }
})